import Image1 from '../../images/services/hrservice.jpg';
import Image2 from '../../images/services/managementservice.jpg';
import Image5 from '../../images/services/payrollservice.jpg';

import icon1 from "../../images/services/icons/icon1.png"

export const service = [
    {
        id: 1,
        sIcon: 'fi flaticon-user',
        Link: '/service/hr-operations-&-administration',
        title: 'HR Operations & Administration',
        des: 'HR Operations & Administration services in Kerala ensure smooth workflows, compliance, and employee satisfaction.',
        // body: `At Befirst HR & Management Consultancy, we specialize in creating robust HR frameworks that empower businesses to operate smoothly, attract top talent, and maintain compliance with legal and organizational standards. Whether you are a startup finding your footing, an SME scaling up, or a corporate aiming for efficiency, our HR solutions are tailored to your growth stage and long-term vision.`,
        // pointTitle: 'Our HR Specializations',
        // points: [
        //     {
        //         title: "HR Audits & Policy Manuals",
        //         desc: "Ensure your HR operations meet compliance standards and reflect your company culture."
        //     },
        //     {
        //         title: "Organizational Structuring",
        //         desc: "Build a clear hierarchy and workflow for efficient decision-making."
        //     },
        //     {
        //         title: "Job Descriptions & Appraisal Systems",
        //         desc: "Define roles, set measurable KPIs, and implement performance evaluation processes."
        //     },
        //     {
        //         title: "Onboarding & Exit Protocols",
        //         desc: "Smooth processes for welcoming talent and managing transitions professionally."
        //     }
        // ],
        // pointTitle2: 'Why Choose Befirst for HR Consultancy?',
        // points2: [
        //     {
        //         title: "HR Audits & Policy Manuals",
        //         desc: "Ensure your HR operations meet compliance standards and reflect your company culture."
        //     },
        //     {
        //         title: "Organizational Structuring",
        //         desc: "Build a clear hierarchy and workflow for efficient decision-making."
        //     },
        //     {
        //         title: "Job Descriptions & Appraisal Systems",
        //         desc: "Define roles, set measurable KPIs, and implement performance evaluation processes."
        //     },
        //     {
        //         title: "Onboarding & Exit Protocols",
        //         desc: "Smooth processes for welcoming talent and managing transitions professionally."
        //     }
        // ],
        // images: Image1
    },

    {
        id: 2,
        sIcon: 'fi flaticon-startup',
        Link: '/service/hr-planning-&-organization',
        title: 'HR Planning & Organization',
        des: 'Strengthen businesses with HR Planning & Organization services in Kerala for people, policies, and performance.',
//         body: `From new employee orientation to employee engagement
// strategies and retention planning, we help organizations
// build a culture that retains talent and supports growth.`,
//         pointTitle: 'Key Programs:',
//         points: [
//             `Orientation Frameworks`,
//             `Employee Engagement Surveys`,
//             `Retention Strategy Development`,
//             `HR Alignment with Business Goals`
//         ],
        // images: img3
    },

    {
        id: 3,
        sIcon: 'fi flaticon-stats',
        Link: '/service/learning-&-development',
        title: 'Learning & Development',
        des: 'Drive productivity and growth using Learning & Development services in Kerala for every business.',
//         body: `At Befirst HR & Management Consultancy, we help entrepreneurs, startups, and established businesses in Kerala reengineer processes, overcome operational challenges, and build sustainable business structures that drive long-term success.
// Whether you are a startup founder in Kochi, an SME owner in Kozhikode, or a corporate leader in Trivandrum, our consultancy solutions are tailored to your needs, helping you optimize efficiency, enhance productivity, and prepare for the future.`,
//         pointTitle: 'Our Core Advisory Areas',
//         points: [
//             {
//                 title: "HR Audits & Policy Manuals",
//                 desc: "Ensure your HR operations meet compliance standards and reflect your company culture."
//             },
//             {
//                 title: "Organizational Structuring",
//                 desc: "Build a clear hierarchy and workflow for efficient decision-making."
//             },
//             {
//                 title: "Job Descriptions & Appraisal Systems",
//                 desc: "Define roles, set measurable KPIs, and implement performance evaluation processes."
//             },
//             {
//                 title: "Onboarding & Exit Protocols",
//                 desc: "Smooth processes for welcoming talent and managing transitions professionally."
//             }
//         ],
//         images: Image2
    },
    {
        id: 4,
        sIcon: 'fi flaticon-trophy',
        Link: '/service/payroll-&-compensation',
        title: 'Payroll & Compensation',
        des: 'Simplify payroll, incentives, and settlements through Payroll & Compensation services in Kerala today.',
//         body: `Our team supports businesses in implementing payroll
// systems (e.g., Zoho, Tally) and provides hands-on training to
// manage payroll, leave, and attendance internally.`,
//         pointTitle: 'Services Offered:',
//         points: [
//             `Payroll & Compliance Setup`,
//             `Leave & Attendance Systems`,
//             `HR/Admin Staff Training on Payroll Management`
//         ],
//         images: Image5
    },

    {
        id: 5,
        sIcon: 'fi flaticon-user',
        Link: '/service/recruitment-assistance',
        title: 'Recruitment Assistance',
        des: 'Find skilled professionals easily with recruitment services in Kerala across industries and business sizes.',
//         body: `Our team supports businesses in implementing payroll
// systems (e.g., Zoho, Tally) and provides hands-on training to
// manage payroll, leave, and attendance internally.`,
//         pointTitle: 'Services Offered:',
//         points: [
//             `Custom HR Workshops for Specific Industries`,
//             `HRMS Software Resale & Implementation`,
//             `Employee Engagement Frameworks`,
//             `Annual HR Retainers for Startups & SMEs`
//         ],
        // images: img6
    },
    {
        id: 6,
        sIcon: 'fi flaticon-business',
        Link: '/service/quality-assurance-&-compliance',
        title: 'Quality Assurance & Compliance',
        des: 'Custom HR workshops, HRMS software implementation, engagement frameworks, and annual HR retainers.',
//         body: `Our training programs focus on improving soft skills,
// workplace efficiency, and leadership development across all
// levels. Sessions are available in English and Malayalam,
// ensuring cultural relevance and maximum engagement.`,
//         pointTitle: 'Training Topics Include:',
//         points: [
//             `Communication & Teamwork`,
//             `Leadership & Emotional Intelligence`,
//             `Sales & Admin Efficiency`,
//             `Functional Skill Building for HR & Operations`
//         ],
        // images:img4
    },
    {
        id: 7,
        sIcon: 'fi flaticon-business',
        Link: '/service/quality-assurance-&-compliance',
        title: 'Talent Acquisition & Onboarding',
        des: 'Ensure smooth workforce integration through Talent Acquisition & Onboarding services in Kerala for all industries.',
       
    },
    {
        id: 8,
        sIcon: 'fi flaticon-business',
        Link: '/service/hr-policy-&-procedure',
        title: 'HR Policy & Procedure ',
        des: 'HR policies set rules defining employer-employee roles, while procedures ensure proper implementation within organizations.',
       
    },
    {
        id: 9,
        sIcon: 'fi flaticon-business',
        Link: '/service/staff-appraisal-system',
        title: 'Staff Appraisal System ',
        des: 'Staff Appraisal System identifies employee strengths and weaknesses, aligns performance with business goals, and enhances growth.',
       
    },
    {
        id: 10,
        sIcon: 'fi flaticon-business',
        Link: '/service/traing-&-development',
        title: 'Training & Development ',
        des: 'Training & Development Services in Calicut, Kerala empower employees, enhance skills, and transform talent into organizational leaders.',
       
    },
    {
        id: 11,
        sIcon: 'fi flaticon-business',
        Link: '/service/customer-care-orientation',
        title: 'Customer Care Orientation ',
        des: 'Befirst HR Consulting provides customized customer care training, ensuring staff build strong relationships and retain every customer.',
       
    },
];
